// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {VueMasonryPlugin} from 'vue-masonry'
import './style/index.css'
import './style/styles.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import 'font-awesome/css/font-awesome.min.css'
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import VueCarousel from 'vue-carousel'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.use(VueCarousel)

Vue.use(VueLazyload,{attempt:1})

Vue.use(VueI18n)
Vue.use(preview,{fullscreenEl:false,bgOpacity:0.7,counterEl:false,zoomEl:false,closeEl:true,showAnimationDuration:0,useLargeImages:false})
Vue.use(VueMasonryPlugin)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

Vue.prototype.imageServer = 'http://www.cmkcg.com/images' //后台图片服务器地址
Vue.prototype.serverUrl = 'http://www.cmkcg.com:9999' //后台服务器请求地址

function getLang(name,defaultValue) {
  var lang = navigator.language || navigator.userLanguage; 
  if(lang==='zh-TW') return 'hk'
  if(lang==='zh-HK') return 'hk'
  return lang.substr(0,2);
}
const i18n = new VueI18n({
  locale: getLang('PLAY_LANG','zh'),  // 语言标识
  // locale: 'zh',
  messages: {
      'zh': require('./i18n/zh'),
      'en': require('./i18n/en'),
      'hk': require('./i18n/hk'),
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js